module.exports = __webpack_public_path__ + "img/logo.3aa6ff0f.png";